module.exports = __webpack_public_path__ + "img/Diversity.593af03d.gif";